export enum CheckState {
  UNCHECKED = 'unchecked',
  CHECKED = 'checked',
  EXCLUDED = 'excluded'
}
